export default "__VITE_ASSET__RmyaCiat__"